declare function require(moduleName: string): any;
const { version: appVersion } = require('../../../package.json')

import {Component, OnInit} from '@angular/core';
import {LoginService} from "../services/login.service";
import {Router} from "@angular/router";
import {ModelService} from "../services/model.service";
import UserCredentials = Sofi.UserCredentials;
import User = Sofi.User;
import {StorageService} from "../services/storage.service";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    triedSubmit: boolean = false;
    public errorMessage: string;
    private userCredentials: UserCredentials = {password: "", username: ""};
    // private userCredentials: UserCredentials = {password: '9992Sofi', username: '9992'};
    version: string;

    constructor(private loginService: LoginService,
                private modelService: ModelService,
                private storageService: StorageService,
                private router: Router) {
        this.version = appVersion;
    }

    ngOnInit() {
    }

    onTouch() {
        this.triedSubmit = true;
    }

    onSubmit() {
        this.errorMessage = '';
        this.loginService.login(this.userCredentials)
            .subscribe((data: User) => {
                this.modelService.user = data;
                this.storageService.saveUser(data);
                this.router.navigate(['/offer']);
            }, (error) => {
                if (error.error[0].message === 'password.wrong') {
                    this.errorMessage = 'Falscher Benutzername oder Passwort.';
                } else {
                    this.errorMessage = 'Unerwarteter Fehler. SoFi steht momentan nicht zur Verfügung';
                    console.log(error);
                }
            });
    }
}
